var map = {
	"./1.png": 3621,
	"./2.png": 3622,
	"./3.png": 3623,
	"./4.png": 3624
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 705;



//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/smilies .\.png*
// module id = 705
// module chunks = 0